import React from "react";

export const Feedback = () => {
    return (
        <div className='feedback-container'>
            <div className='feedback-container__content'>
                <h5>Muchas gracias</h5>
                <p>
                    Muchas gracias por contactarte con el canal de denuncias.{" "}
                    <br />
                    Te informamos que a partir de hoy comienza a regir el plazo
                    estipulado para la investigación de esta denuncia o
                    consulta.
                </p>
            </div>

            <img className="feedback-container__img" src={`${window._env_.STATIC_HOST}/static/website/images/complait-feedback-bg.png`} alt="Imagen decorativa de una suv C-HR hybrid" />

            <div className="feedback-container__cta">
                <a className='btn white' href='/'>
                    Ir al inicio
                </a>
            </div>
        </div>
    );
};
